<template>
  <div class="container">
    <div class="banner_wrapper">
      <div class="banner_img_content">
        <img class="banner_img" src="@/assets/images/ourwork_banner.png" alt="Banner" />
      </div>
      <div class="banner_content">
        <div class="banner_border"></div>
        <div class="banner_tag">
          <div class="title">OUR WORK</div>
          <div class="description">
            Where Compassion Meets Action for a Better World
          </div>
        </div>
      </div>
    </div>
    <div class="content_wrapper">
      <div
        v-for="(data, index) in projectList"
        class="content"
        :key="index"
        @click="linkToDetail('ourwork', data.projectId)"
      >
        <img class="content_img" :src="data.coverUrl" alt="" />
        <div class="content_info">
          <div class="content_title">{{ data.title }}</div>
          <div class="content_description">
            {{ data.describe }}
          </div>
          <div class="give_now">
            <span
              @click.stop="
                open = true;
                dedicateId = data.projectId;
              "
            >
              Give Now
            </span>
            <span>|</span>
            <img src="@/assets/images/arrow_white.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
    <a-modal class="custom_modal" v-model:open="open" :closable="false" :footer="null">
      <div class="tag">Thank you for your dedication!</div>
      <Payment :dedicateId="dedicateId" />
    </a-modal>
  </div>
</template>

<script setup>
import { LoadingOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import { computed, ref, reactive, onMounted, toRaw, h, nextTick, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

import { fetchHomeProjectList } from '@/api/common';
import Payment from '@/components/Payment.vue';

const route = useRoute();
const router = useRouter();
const store = useStore();
const projectList = ref([]);
const open = ref(false);
const dedicateId = ref();

const getProjectList = () => {
  fetchHomeProjectList().then((res) => {
    if (res.code == 200) {
      projectList.value = res.data;
    }
  });
};

const linkToDetail = (type, id) => {
  router.push(`/${type}/detail/${id}`);
};

onMounted(() => {
  getProjectList();
});
</script>

<style lang="less">
.custom_modal {
  .ant-modal-content {
    border-radius: 20px;
    .payment_wrapper {
      margin-top: 80px;
    }
    .tag {
      position: absolute;
      border-radius: 20px 20px 0 0;
      left: 0;
      right: 0;
      top: 0;
      height: 64px;
      background: #05644f;
      font-size: 20px;
      font-weight: bold;
      line-height: 64px;
      color: #ffffff;
      text-align: center;
    }
  }
}
</style>

<style lang="less" scoped>
.container {
  .banner_wrapper {
    position: relative;
    margin: 0 auto;
    max-width: 1920px;
    max-height: 500px;
    .banner_img_content {
      padding-bottom: calc(100% * (20 / 192));
      min-height: 200px;
      .banner_img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .banner_content {
      width: 1080px;
      margin: 0 auto;
      position: absolute;
      left: calc(50% - 540px);
      top: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      .banner_border {
        width: 150px;
        height: 150px;
        border: 6px solid #f78335;
      }
      .banner_tag {
        color: #fff;
        position: absolute;
        left: 60px;
        background: rgba(0, 0, 0, 0.25);
        width: 320px;
        padding: 12px 24px;
        letter-spacing: 2px;
        .title {
          font-size: 24px;
          font-weight: bold;
          margin-bottom: 10px;
        }
        .description {
          font-size: 18px;
        }
      }
    }
    @media (max-width: 1080px) {
      .banner_content {
        width: 100%;
        left: 0;
      }
    }
  }
  .content_wrapper {
    width: 1080px;
    margin: 100px auto;
    display: flex;
    flex-wrap: wrap;
    gap: 40px;
    justify-content: center;
    padding: 10px 0;
    .content {
      width: calc(33.33% - 27px);
      background: #ffffff;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
      border-radius: 16px;
      position: relative;
      cursor: pointer;
      padding: 20px;
      @supports (-webkit-transform-style: preserve-3d) {
        &:hover {
          -webkit-transform: translateY(-2px);
          transform: translateY(-2px);
        }
      }
      .content_img {
        width: 100%;
        border-radius: 16px 16px 0 0;
        height: 188px;
      }
      .content_info {
        height: 255px;
        .content_title {
          font-size: 20px;
          font-weight: bold;
          margin: 12px 0;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
          height: 48px;
        }
        .content_description {
          margin-bottom: 16px;
          line-height: 20px;
          color: #666;
          height: 176px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 9;
          -webkit-box-orient: vertical;
        }
      }
      .give_now {
        width: 100%;
        height: 60px;
        border-radius: 20px;
        background: linear-gradient(283deg, #f78335 0%, #3b927e 100%);
        font-weight: bold;
        color: #fff;
        justify-content: space-between;
        align-items: center;
        padding: 0 40px;
        cursor: pointer;
        position: absolute;
        bottom: 0;
        left: 0;
        display: flex;
        visibility: hidden;
        opacity: 0;
        transition: visibility 0s 1s, opacity 1s ease;
      }
      &:hover {
        .give_now {
          visibility: visible;
          opacity: 1;
          transition-delay: 0s;
        }
      }
    }
  }
  @media (max-width: 1080px) {
    .content_wrapper {
      width: 100%;
      margin: 48px auto;
      .content {
        width: calc(50% - 24px);
        .content_img {
          height: 300px;
        }
      }
    }
  }
  @media (max-width: 768px) {
    .content_wrapper {
      .content {
        width: 90%;
        .content_img {
          height: 200px;
        }
      }
    }
  }
}
</style>
